import React, { useEffect, useRef } from "react";
import { Box, Container, Typography, Button } from "@mui/material";
import { Link } from "react-router-dom";

const AboutSecondSection = () => {
  const tiltRef = useRef(null);

  useEffect(() => {
    const el = tiltRef.current;
    if (!el) return;

    const move = (e) => {
      const r = el.getBoundingClientRect();
      const x = e.clientX - r.left;
      const y = e.clientY - r.top;
      const rx = ((y / r.height) - 0.5) * -6;
      const ry = ((x / r.width) - 0.5) * 6;
      el.style.transform = `perspective(1000px) rotateX(${rx}deg) rotateY(${ry}deg)`;
    };

    const reset = () =>
      (el.style.transform = "perspective(1000px) rotateX(0) rotateY(0)");

    el.addEventListener("mousemove", move);
    el.addEventListener("mouseleave", reset);
    return () => {
      el.removeEventListener("mousemove", move);
      el.removeEventListener("mouseleave", reset);
    };
  }, []);

  return (
    <>
      <style>{`
        .about-sec {
          padding: 120px 0;
          background: #ffffff;
        }

        .about-flex {
          display: flex;
          align-items: center;
          gap: 90px;
          flex-wrap: wrap;
        }

        .about-left {
          position: relative;
          flex: 1 1 520px;
        }

        .about-right {
          flex: 1 1 420px;
        }

        /* IMAGE STACK */
        .img-main {
          position: relative;
          border-radius: 28px;
          overflow: hidden;
        }

        .img-main img {
          width: 100%;
          display: block;
          transition: transform .4s cubic-bezier(.03,.98,.52,.99);
        }

        .img-small-top {
          position: absolute;
          top: -40px;
          left: -40px;
          width: 160px;
          border-radius: 20px;
          overflow: hidden;
          box-shadow: 0 20px 40px rgba(0,0,0,.15);
          z-index: 3;
        }

        .img-small-right {
          position: absolute;
          bottom: 40px;
          right: -60px;
          width: 190px;
          border-radius: 22px;
          overflow: hidden;
          box-shadow: 0 25px 50px rgba(0,0,0,.18);
          z-index: 3;
        }

        /* PLAY BUTTON */
        .play-wrap {
          position: absolute;
          inset: 0;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .play-btn {
          width: 84px;
          height: 84px;
          border-radius: 50%;
          border: 2px solid #7ac142;
          color: #7ac142;
          font-size: 26px;
          display: flex;
          align-items: center;
          justify-content: center;
          background: rgba(255,255,255,.7);
          animation: pulse 2.2s infinite;
        }

        @keyframes pulse {
          0% { box-shadow: 0 0 0 0 rgba(122,193,66,.45); }
          70% { box-shadow: 0 0 0 22px rgba(122,193,66,0); }
          100% { box-shadow: 0 0 0 0 rgba(122,193,66,0); }
        }

        /* EXPERIENCE BADGE */
        .exp-card {
          position: absolute;
          bottom: -40px;
          left: -30px;
          background: #fff;
          border-radius: 24px;
          padding: 22px 26px;
          box-shadow: 0 30px 70px rgba(0,0,0,.12);
          text-align: center;
          z-index: 4;
        }

        .exp-text {
          writing-mode: vertical-rl;
          transform: rotate(180deg);
          font-size: 13px;
          color: #6b7280;
          letter-spacing: 1px;
          margin-bottom: 8px;
        }

        .exp-number {
          font-size: 44px;
          font-weight: 800;
          color: #7ac142;
        }

        /* RIGHT CONTENT */
        .about-label {
          color: #7ac142;
          font-weight: 600;
          font-size: 13px;
          letter-spacing: 2px;
          display: inline-flex;
          align-items: center;
          gap: 12px;
          margin-bottom: 14px;
        }

        .about-label::after {
          content: "";
          width: 40px;
          height: 2px;
          background: #7ac142;
        }

        .title {
          font-size: 44px;
          font-weight: 800;
          line-height: 1.15;
          margin-bottom: 18px;
        }

        .desc {
          color: #6b7280;
          font-size: 16px;
          line-height: 1.7;
          margin-bottom: 26px;
        }

        .list li {
          list-style: none;
          display: flex;
          gap: 10px;
          margin-bottom: 12px;
          font-size: 15px;
        }

        .list li::before {
          content: "";
          width: 10px;
          height: 10px;
          background: #7ac142;
          border-radius: 50%;
          margin-top: 6px;
        }

        .cta {
          margin-top: 32px;
          background: #7ac142;
          color: #fff;
          padding: 14px 38px;
          border-radius: 999px;
          font-weight: 600;
          text-transform: none;
          box-shadow: 0 22px 44px rgba(122,193,66,.4);
        }

        @media (max-width: 900px) {
          .about-flex { gap: 60px; }
          .img-small-top, .img-small-right { display: none; }
          .exp-card { position: relative; left: 0; bottom: 0; margin-top: 20px; }
          .title { font-size: 34px; }
        }
          .about-left {
  position: relative; /* anchor for absolute children like exp-card */
}

/* experience overlay card */
.exp-card{
  position: absolute;
  left: 20px;
  bottom: 20px;
  z-index: 5;

  display: flex;
  flex-direction: column;
  align-items: flex-start;

  width: max-content;      /* prevents full-width expansion */
  max-width: 220px;        /* safety */
  padding: 14px 16px;

  background: #fff;
  border-radius: 12px;
  box-shadow: 0 10px 30px rgba(0,0,0,.15);
}

/* mobile tweaks only (still overlay) */
@media (max-width: 768px){
  .exp-card{
    left: 12px;
    bottom: 12px;
    padding: 12px 14px;
    max-width: 200px;
  }

  .exp-number{
    font-size: 32px; /* adjust to match your desktop look */
    line-height: 1;
  }
}

      `}</style>

      <Box className="about-sec">
        <Container>
          <Box className="about-flex">

            {/* LEFT */}
            <Box className="about-left"  sx={{ position: "relative" }}>
              <Box className="img-small-top">
                <img src="https://html.themehour.net/kleanix/demo/assets/img/about/about-1-left.jpg" alt="" />
              </Box>

              <Box className="img-main">
                <img
                  ref={tiltRef}
                  src="https://html.themehour.net/kleanix/demo/assets/img/about/about-1-main.jpg"
                  alt="Cleaning"
                />
                <Box className="play-wrap">
                  {/* <a
                    href="https://www.youtube.com/watch?v=_sI_Ps7JSEk"
                    className="play-btn"
                    target="_blank"
                    rel="noreferrer"
                  > */}
                    ▶
                  {/* </a> */}
                </Box>
              </Box>

              <Box className="img-small-right">
                <img src="https://html.themehour.net/kleanix/demo/assets/img/about/about-1-right.jpg" alt="" />
              </Box>

              <Box className="exp-card">
                <div className="exp-text">Years of Experience</div>
                <div className="exp-number">16</div>
              </Box>
            </Box>

            {/* RIGHT */}
            <Box className="about-right">
              <Typography className="about-label">ABOUT US</Typography>
              <Typography className="title">
               Redefining Home Maintenance with Speed & Affordability.
              </Typography>
              <Typography className="desc">
                We are Rite Home Pros. Your 24/7 partner for a safer, cleaner, and more comfortable home.
              </Typography>

              <ul className="list">
                <li>One-off, weekly or fortnightly visits</li>
                <li>Vetted & background-checked cleaners</li>
                <li>Road Test Preparation with 98% success</li>
                <li>Book, manage & pay online</li>
              </ul>

              <Button component={Link} to="/services" className="cta">
                Discover More
              </Button>
            </Box>

          </Box>
        </Container>
      </Box>
    </>
  );
};

export default AboutSecondSection;
